import { useRouter } from 'next/router';
import { useAccount } from 'wagmi';

import { isLedgerConnectorId } from '@/config/ledgerLive';

import { WALLET_KEYS } from '../constants/common';

export const useEmbed = () => {
  const { connector } = useAccount();
  const router = useRouter();

  const isLedger = Boolean(router.query.embed);

  const isSafeApp = connector?.id === WALLET_KEYS.SAFE;
  // Ledger surfaces as either the EIP-6963 connector or the injected fallback.
  const isEmbed = isLedgerConnectorId(connector?.id) || isLedger;

  return { isEmbed, isSafeApp };
};
